import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useGoogleLogin } from '@react-oauth/google';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { storeData } from 'src/helper/storageHelper';
import { constants, showErrorTost, showSuccessTost } from 'src/constants';
import { SOCIAL_LOGIN } from 'src/apiService/apiDeclaration';
import { getLoggedInUser } from 'src/redux/features/auth/actions';
import { setToken } from 'src/redux/features/auth/slice';

const SocialLogin = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const onGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      await onSocialLogin(tokenResponse);
    },
    onError: (error) => {
      showErrorTost(error?.error_description || t('common.socialLoginFailed'));
    },
  });

  const onSocialLogin = async (tokenResponse) => {
    setLoading(true);
    try {
      const resp = await SOCIAL_LOGIN(tokenResponse);
      storeData(constants.authToken, resp.data.token);
      dispatch(setToken(resp.data.token));
      // Without this the token is stored but state.user stays null, so App.js
      // keeps rendering AuthRouter and the user appears stuck on the login screen.
      await dispatch(getLoggedInUser());
      showSuccessTost(resp.message);
    } catch (error) {
      showErrorTost(error.message);
    } finally {
      setLoading(false);
    }
  };

  const platform = [
    {
      icon: (
        <img
          src={
            'https://firebasestorage.googleapis.com/v0/b/jacques-bf86d.appspot.com/o/jacquesAssets%2FgoogleLogo.png?alt=media&token=baeb8119-7004-42ed-a780-2dd79902e6f0'
          }
          width={25}
          height={25}
          alt="google"
        />
      ),
      title: 'google',
      onClick: onGoogleLogin,
    },
  ];
  return (
    <Stack gap={3}>
      <Typography variant="body2" textAlign={'center'} color={'#b4b4b7'}>
        {t('common.connectOption')}
      </Typography>
      <Grid>
        {platform.map(({ icon, title, color, onClick }, index) => (
          <Button
            disabled={loading}
            key={index}
            fullWidth
            size="small"
            variant="outlined"
            onClick={onClick}
            sx={{
              backgroundColor: color,
              '&:hover': {
                backgroundColor: color,
              },
            }}
            startIcon={icon}
          >
            {title}
          </Button>
        ))}
      </Grid>
    </Stack>
  );
};

export default SocialLogin;
